import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jem-open/jem-ui";

export interface MoveSiteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  siteName: string | null;
  destinationRegions: { id: string; name: string }[];
  destination: string;
  onDestinationChange: (id: string) => void;
  onConfirm: () => void;
}

/** Move a Site to another Region. Used on the Sites & Regions overview. */
export const MoveSiteDialog: React.FC<MoveSiteDialogProps> = ({
  open,
  onOpenChange,
  siteName,
  destinationRegions,
  destination,
  onDestinationChange,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Move Site to another Region</DialogTitle>
        <DialogDescription>
          {siteName && (
            <>
              Move <strong>{siteName}</strong> to another Region. All Rosters
              and Site settings travel with the Site.
            </>
          )}
        </DialogDescription>
      </DialogHeader>
      <div className="mt-md space-y-xxs">
        <Label>Destination Region</Label>
        <Select value={destination} onValueChange={onDestinationChange}>
          <SelectTrigger>
            <SelectValue placeholder="Select a Region" />
          </SelectTrigger>
          <SelectContent>
            {destinationRegions.map((r) => (
              <SelectItem key={r.id} value={r.id}>
                {r.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button variant="default" disabled={!destination} onClick={onConfirm}>
          Move Site
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default MoveSiteDialog;
